var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"bb-nested-view"},[_c('h1',[_vm._v("Partners Sub Route")]),_c('h2',[_vm._v("CONTENT HERE")]),_c('h3',[_vm._v("CONTENT HERE")]),_c('h4',[_vm._v("CONTENT HERE")]),_c('h5',[_vm._v("CONTENT HERE")])])
}]

export { render, staticRenderFns }